import React from "react";
import { ResourceDWR } from "../../../dto/ResourceDWR";
import { useLanguage } from "../../Language";
import { useLocationConfiguration } from "../../LocationConfiguration";
import { Typography } from "@mui/material";

interface ReadingLevelSummaryProps {
  resource: ResourceDWR;
}
export const ReadingLevelSummary: React.FC<ReadingLevelSummaryProps> = ({
  resource,
  ...props
}: ReadingLevelSummaryProps) => {
  const { translate } = useLanguage();
  const { locationConfiguration } = useLocationConfiguration();
  const { lexileDisplay } = resource?.lexile || {};
  const { bookLevel, arPoints, quizNumber, interestLevel } =
    resource?.acceleratedReader || {};
  const {
    lexileEnabled,
    acceleratedReaderEnabled,
    acceleratedReaderShowQuizNumber,
  } = locationConfiguration?.pacSettings || {};
  return (
    <>
      {lexileEnabled && lexileDisplay && (
        <>
          <Typography variant="h6" component={"h4"}>
            {translate("lexileMeasure")}
          </Typography>
          <ul style={{ margin: "0 0 16px 0", listStyle: "none" }}>
            <li>{lexileDisplay}</li>
          </ul>
        </>
      )}
      {acceleratedReaderEnabled && bookLevel && (
        <>
          <Typography variant="h6" component={"h4"}>
            {translate("atosLevel")}
          </Typography>
          <ul style={{ margin: "0 0 16px 0", listStyle: "none" }}>
            <li>{bookLevel}</li>
          </ul>
        </>
      )}
      {acceleratedReaderEnabled && interestLevel && (
        <>
          <Typography variant="h6" component={"h4"}>
            {translate("interestLevel")}
          </Typography>
          <ul style={{ margin: "0 0 16px 0", listStyle: "none" }}>
            <li>{interestLevel}</li>
          </ul>
        </>
      )}

      {acceleratedReaderEnabled && arPoints && (
        <>
          <Typography variant="h6" component={"h4"}>
            {translate("arPoints")}
          </Typography>
          <ul style={{ margin: "0 0 16px 0", listStyle: "none" }}>
            <li>{arPoints}</li>
          </ul>
        </>
      )}

      {acceleratedReaderEnabled &&
        acceleratedReaderShowQuizNumber &&
        quizNumber && (
          <>
            <Typography variant="h6" component={"h4"}>
              {translate("quizNumber")}
            </Typography>
            <ul style={{ margin: "0 0 16px 0", listStyle: "none" }}>
              <li>{quizNumber}</li>
            </ul>
          </>
        )}
    </>
  );
};
